export default {
  //  应用管理列表
  getIsvAppList: '/agency/app_info/get_app_list',
  //  应用管理详情
  getIsvAppDetail: '/agency/app_info/get_app',
  //  更新应用
  applyEdit: '/agency/app_info/update_app_info',
  //  添加应用
  applyAdd: '/agency/app_info/add_app_info',
  fileUpload: '/isv_service/v1/agency/update_file',
  // 支持上传视频的接口
  publicFileUpload: '/isv_service/v1/public/uploadFile',
};
